<script setup>
  import ListeRecapInventaire from '@/components/ListeRecapInventaire.vue'

</script>

<template>
  <button class="back mt-4" @click="goBack"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
    </svg>Retour</button>
  <h1>Recap de l'inventaire du {{ formatDate(date) }} par {{ nom }} {{ prenom }}</h1>
  <div class="home">
    <ListeRecapInventaire/>
  </div>
</template>

<script>


export default {
  data() {
        return {
          date: null,
          nom: null,
          prenom: null
        };
    },
    created() {
      this.date = this.$route.params.date;
      this.prenom = this.$route.params.prenom;
      this.nom = this.$route.params.nom;
    },
    methods: {
      formatDate(date) {
        // Extraire les parties de la date
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);

        // Concaténer les parties dans l'ordre souhaité
        const formattedDate = `${day}-${month}-${year}`;

        // Renvoyer la date formatée
        return formattedDate;
      },
      goBack() {
          const queryParams = {
            page: this.currentPage,
            searchTerm: this.searchTerm,
          };
          this.$router.go(-1);
          this.$router.push({ query: queryParams });
      },
    }
}
</script>

<style>


</style>
